import { createPropertyHooks } from '@markku/components'

import { trpc } from '../trpc'

export const propertyHooks = createPropertyHooks(trpc)
